import React from 'react';
import styled from 'styled-components';
import { distribution } from '../reportModel';
import { DISTRIBUTION_COLORS } from '../reportPalette';

const Track = styled.div`
  display: flex;
  width: 100%;
  height: ${({ $h }) => $h}px;
  border-radius: 3px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.report.grayLight};
`;

const Seg = styled.div`
  height: 100%;
  width: ${({ $w }) => $w}%;
`;

export default function DistributionBar({ result, height = 14 }) {
  const d = distribution(result);
  return (
    <Track $h={height} data-testid="distribution-bar">
      <Seg $w={d.unfavorable} style={{ backgroundColor: DISTRIBUTION_COLORS.unfavorable }} data-part="unfavorable" />
      <Seg $w={d.neutral} style={{ backgroundColor: DISTRIBUTION_COLORS.neutral }} data-part="neutral" />
      <Seg $w={d.favorable} style={{ backgroundColor: DISTRIBUTION_COLORS.favorable }} data-part="favorable" />
    </Track>
  );
}
